<template>
    <div>
        <Tabs
            v-if="loaded"
            :data="data"
            ref="Tabs"
        />
    </div>
</template>

<script>
// Components.
import Tabs from './Tabs'

// Others.
import { mapActions } from 'vuex'
import { object, stringCase, repository, error } from '@/mixins'

export default {
    components: { Tabs },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('farmacia.parametrizacao'),
        }

        this.load()
    },
    data: () => ({
        data: null,
        loaded: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(({ data }) => {

                    this.data = data

                    this.$emit('data-load', this.data)

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Tabs.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.parametrizacao.store(this.prepareData())
                        .then(() => {

                            this.$emit('save')
                            this.showSaveNotification()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const data = this.clone({
                medicamentoSupervisor: this.data.medicamentoSupervisor,
                posologia: this.data.posologia,
                dispensacao: this.data.dispensacao,
                limitePrescricaoMedicamento: this.data.limitePrescricaoMedicamento,
                appCidadao: this.data.appCidadao,
                altoCusto: this.data.altoCusto,
            })

            return this.camelObjectKeysToSnakeRecursive(data)
        }
    },
    mixins: [object, stringCase, repository, error]
}
</script>